import { TStringField, TLinkField, TImageField, TSitecoreContext } from '../../../types/sitecore.types';
import { THeadingTag } from '../../../types/types';
import { TKeepTouchFields, TKeepTouchParams, TKeepTouchProps } from '../types/keepTouch.types';

export class KeepTouchModel {
  private readonly fields: null | TKeepTouchFields;
  private readonly params: TKeepTouchParams | undefined;
  private readonly context?: TSitecoreContext;

  constructor(props: TKeepTouchProps) {
    this.fields = props?.fields || null;
    this.params = props?.params;
    this.context = props?.sitecoreContext;
  }

  get keepTitle(): TStringField | undefined {
    return this.fields?.keepTitle;
  }

  get keepContent(): TStringField | undefined {
    return this.fields?.keepContent;
  }

  get keepLink(): TLinkField | undefined {
    return this.fields?.keepLink;
  }

  get supportTitle(): TStringField | undefined {
    return this.fields?.supportTitle;
  }

  get supportContent(): TStringField | undefined {
    return this.fields?.supportContent;
  }

  get supportLink(): TLinkField | undefined {
    return this.fields?.supportLink;
  }

  get backgroundImage(): TImageField | undefined {
    return this.fields?.backgroundImage;
  }

  get backgroundMobileImage(): TImageField | undefined {
    return this.fields?.backgroundMobileImage;
  }

  get defaultBgDesktopImage(): TImageField | undefined {
    return {
      value: {
        src: this.context?.defaultBackgroundImageParameters?.desktopImageData?.keepInTouch,
      },
    };
  }

  get defaultBgMobileImage(): TImageField | undefined {
    return {
      value: {
        src: this.context?.defaultBackgroundImageParameters?.mobileImageData?.keepInTouch,
      },
    };
  }

  get desktopBgImage(): TImageField | undefined {
    return this.backgroundImage?.value?.src ? this.backgroundImage : this.defaultBgDesktopImage;
  }

  get mobileBgImage(): TImageField | undefined {
    return this.backgroundMobileImage?.value?.src ? this.backgroundMobileImage : this.defaultBgMobileImage;
  }

  get headingTag(): THeadingTag {
    return (this.params?.headingTag?.toLowerCase() as THeadingTag) || 'h2';
  }

  get isUnreleased(): boolean {
    return !!this.fields?.isComponentUnreleased;
  }
}
